<div class="ticket-log-table">
  <div class="ticket-details">
    <div class="ticket-detail-info">
      <div class="ticket-info-label">
        <ng-container *ngIf="ticket.MediaType === 0">{{ 'fgbcl.ticket.transfer.log.card.no' | translate }}</ng-container>
        <ng-container *ngIf="ticket.MediaType === 1">{{ 'fgbcl.ticket.transfer.log.ticket.no' | translate }}:</ng-container>
      </div>
      <div class="ticket-info-value">
        {{ ticket.ACN }}
      </div>
    </div>
    <div class="ticket-detail-info" *ngIf="ticketColumn1 !== ticketDetails.Hide">
      <div class="ticket-info-label">
        {{ 'fgbcl.ticket.transfer.log.area' | translate }}
      </div>
      <div class="ticket-info-value">
        <ng-container [ngSwitch]="ticketColumn1">
          <span *ngSwitchCase="ticketDetails.AreaLine1" class="text-primary">{{ ticket.AreaLine1 }}</span>
          <span *ngSwitchCase="ticketDetails.Stand" class="text-primary">{{ ticket.Stand }}</span>
          <span *ngSwitchCase="ticketDetails.StandName" class="text-primary">{{ ticket.StandName }}</span>
          <span *ngSwitchDefault class="text-primary">{{ ticket.Area }}</span>
        </ng-container>
      </div>
    </div>
    <div class="ticket-detail-info" *ngIf="ticketColumn2 !== ticketDetails.Hide">
      <div class="ticket-info-label">{{ 'fgbcl.ticket.transfer.log.section' | translate }}</div>
      <div class="ticket-info-value">
        <ng-container [ngSwitch]="ticketColumn2">
          <span *ngSwitchCase="ticketDetails.AreaLine1" class="text-primary">{{ ticket.AreaLine1 }}</span>
          <span *ngSwitchCase="ticketDetails.Area" class="text-primary">{{ ticket.Area }}</span>
          <span *ngSwitchCase="ticketDetails.StandName" class="text-primary">{{ ticket.StandName }}</span>
          <span *ngSwitchDefault class="text-primary">{{ ticket.Stand }}</span>
        </ng-container>
      </div>
    </div>
    <div class="ticket-detail-info d-none d-lg-flex" *ngIf="ticket.Row">
      <div class="ticket-info-label">{{ 'fgbcl.ticket.transfer.log.row' | translate }}</div>
      <div class="ticket-info-value">{{ ticket.Row }}</div>
    </div>
    <div class="d-flex">
      <div class="ticket-detail-info me-3">
        <div class="ticket-info-label">{{ 'fgbcl.ticket.transfer.log.seat' | translate }}</div>
        <div class="ticket-info-value">{{ ticket.Seat }}</div>
      </div>

      <div class="ticket-detail-info d-flex d-lg-none" *ngIf="ticket.Row">
        <div class="ticket-info-label">{{ 'fgbcl.ticket.transfer.log.row' | translate }}</div>
        <div class="ticket-info-value">{{ ticket.Row }}</div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="ticketLog$ | async as ticketLog">
  <ng-container *ngIf="ticketLog.length > 0; else noLogItems">
    <div class="ticket-transfer-log-history-list">
      <div class="ticket-transfer-log-history" *ngFor="let log of ticketLog">
        <ng-container *ngIf="log.ATTENDANCE; else notAttended">
          <div class="ticket-tranfer-history-detail">
            <div class="info-detail-name">
              {{ log.TransfereeFullName }}
            </div>
            <div class="info-detail-email">({{ log.EmailAddress }})</div>
            <div class="info-detail-date">
              {{ log.ATTENDANCE | date }}
            </div>
          </div>
          <div class="ticket-transfer-log-status">
            {{ 'fgbcl.ticket.transfer.log.attended' | translate }}
          </div>
        </ng-container>
        <ng-template #notAttended>
          <div class="ticket-tranfer-history-detail">
            <div class="info-detail-name">{{ log.TransfereeFullName }}</div>
            <div class="info-detail-email">({{ log.TransfereeEmailAddress }})</div>

            <div class="info-detail-date">{{ log.Date | date: 'd MMM y  h:mm a' }}</div>
          </div>

          <div
            class="ticket-transfer-log-status"
            [ngClass]="{
              'called-back': log.TransactionTypeId === 14,
              transferred: log.TransactionTypeId === 13,
              attendance: log.ATTENDANCE,
            }"
          >
            <div class="ticket-transfer-log-status">{{ ticketTransferStatus(log.TransactionTypeId) }}</div>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #noLogItems>
  <div class="no-items text-center p-4">{{ 'fgbcl.ticket.transfer.no.transfer.logs' | translate }}</div>
</ng-template>
